export const SUGGESTIONS_RESPONSE_TIMEOUT_MS = 1000 * 15;
